"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asset = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const globalTypes_1 = require("../../__types__/globalTypes");
const Branch_1 = require("./Branch");
const UnitTypeTitle_1 = require("./UnitTypeTitle");
const useAssetChildren_1 = require("./useAssetChildren");
function Asset({ asset, selection, onSelect, }) {
    var _a, _b;
    const did = (_a = asset.unitAddress) === null || _a === void 0 ? void 0 : _a.did;
    if (!did) {
        throw new Error('No did in unit');
    }
    const handleLabelClick = react_1.useCallback((e) => {
        onSelect(createSelection({ type: 'did', did }, selection, e.ctrlKey || e.metaKey));
    }, [did, onSelect, selection]);
    const isSelected = react_1.useMemo(() => selection.some(selection => selection.type === 'did' && selection.did === did), [did, selection]);
    const isExpandable = react_1.useMemo(() => { var _a; return !!((_a = asset === null || asset === void 0 ? void 0 : asset.assetChildren) === null || _a === void 0 ? void 0 : _a.filter(x => (x === null || x === void 0 ? void 0 : x.unitTypeFixed) !== globalTypes_1.UnitType.physicalOrChassis).length); }, [asset === null || asset === void 0 ? void 0 : asset.assetChildren]);
    return (jsx_runtime_1.jsx(Branch_1.Branch, Object.assign({ label: (_b = asset.name) !== null && _b !== void 0 ? _b : 'Unlabeled asset', onClickLabel: handleLabelClick, selected: isSelected, isExpandable: isExpandable }, { children: jsx_runtime_1.jsx(Children, { assetParentDid: did, selection: selection, onSelect: onSelect }, void 0) }), void 0));
}
exports.Asset = Asset;
function Children({ assetParentDid, selection, onSelect, }) {
    const locationId = __1.useLocationId();
    const { data, loading } = useAssetChildren_1.useAssetChildren(locationId, assetParentDid);
    const filteredData = react_1.useMemo(() => lodash_1.orderBy(data !== null && data !== void 0 ? data : [], ['name']).filter(asset => asset.unitTypeFixed !== globalTypes_1.UnitType.physicalOrChassis), [data]);
    const handleUnitTypeClick = react_1.useCallback((unitType) => (e) => {
        onSelect(createSelection({
            type: 'unitTypeInParent',
            parentDid: assetParentDid,
            unitType,
        }, selection, e.ctrlKey || e.metaKey));
    }, [assetParentDid, onSelect, selection]);
    const assetsByType = react_1.useMemo(() => {
        return lodash_1.orderBy(Object.entries(lodash_1.groupBy(filteredData, x => x.unitTypeFixed)), x => getPriority(x[0]), 'desc');
    }, [filteredData]);
    const isSelected = (type) => selection.some(selection => selection.type === 'unitTypeInParent' &&
        selection.parentDid === assetParentDid &&
        selection.unitType === type);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [loading ? (jsx_runtime_1.jsx(react_ui_1.Box, { children: jsx_runtime_1.jsx(react_ui_1.BarLoader, {}, void 0) }, void 0)) : null,
            assetsByType.map(([type, assets]) => (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx(UnitTypeTitle_1.UnitTypeTitle, Object.assign({ onClick: handleUnitTypeClick(type), isSelected: isSelected(type) }, { children: __1.ucfirst(__1.unitTypeToString(type, { plural: true })) }), void 0),
                    assets.map((asset, i) => {
                        var _a, _b;
                        return (jsx_runtime_1.jsx(Asset, { asset: asset, selection: selection, onSelect: onSelect }, (_b = (_a = asset === null || asset === void 0 ? void 0 : asset.unitAddress) === null || _a === void 0 ? void 0 : _a.did) !== null && _b !== void 0 ? _b : i));
                    })] }, type)))] }, void 0));
}
function getPriority(unitType) {
    const lookup = priorities[unitType];
    if (lookup !== undefined) {
        return lookup;
    }
    return 0;
}
function createSelection(newSelection, oldSelection, additive) {
    const oldSelectionWithoutNew = oldSelection.filter(selection => !lodash_1.isEqual(selection, newSelection));
    if (additive) {
        if (oldSelectionWithoutNew.length > 0 &&
            oldSelectionWithoutNew.length !== oldSelection.length) {
            return oldSelectionWithoutNew;
        }
        else {
            return [...oldSelectionWithoutNew, newSelection];
        }
    }
    else {
        return [newSelection];
    }
}
const priorities = {
    [globalTypes_1.UnitType.conferenceRoom]: 5,
    [globalTypes_1.UnitType.area]: 3,
};
//# sourceMappingURL=Asset.js.map